import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { store } from '../../../../store/store';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../../Modules/Acl/Components/AclContextProvider';
import ManagerNavigation from './ManagerNavigation';
import { ManagerContextProvider } from '../../Services/ManagerContext';
import { parseBoolean } from '../../../../Utils/form.util';

loadDOMComponent({
	selector: 'react-manager-navigation',
	callback: ({ container, context }: any) => {
		const workplaceId = container.getAttribute('workplaceId');
		const isSuperAdmin = parseBoolean(container.getAttribute('isSuperAdmin'));

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<ManagerContextProvider
							workplaceId={workplaceId}
							isSuperAdmin={isSuperAdmin}>
							<ManagerNavigation isSuperAdmin={isSuperAdmin} />
						</ManagerContextProvider>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
